import { useTranslation } from 'react-i18next';
import { COLOR_MODES } from '../../theme/colorMode';
import { useColorMode } from '../../theme/ThemeProvider';
import { cn } from '../../lib/utils';

const ColorModeSelect = () => {
  const { t } = useTranslation();
  const { mode, setMode } = useColorMode();

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{t('settings.general.appareance.color_mode')}</p>
      <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-muted">
        {COLOR_MODES.map((option) => (
          <button
            type="button"
            key={option}
            onClick={() => setMode(option)}
            className={cn(
              'px-3 py-1.5 text-sm rounded-md transition-colors',
              mode === option
                ? 'bg-card shadow-sm text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {t(`settings.general.appareance.color_mode.${option}`)}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">{t('settings.general.appareance.color_mode.hint')}</p>
    </div>
  );
};

export default ColorModeSelect;
